// The horizontal "common devices" row that sits above the room list on the
// Rooms screen and above the device grid on the Devices screen (identical code
// in roomsScreen.dart and devicesScreen.dart).
//
// PINNED, NOT SCROLLED AWAY. Both screens place this as a fixed row above their
// scrolling list — the Dart has it as a plain child of a Column with the list in
// an Expanded below, so it never leaves the screen. It owns its own horizontal
// scroll; the list below owns the vertical one. Putting it inside the vertical
// scroller (as an earlier version did) makes common devices disappear as soon as
// you scroll the rooms, which is exactly what they must not do.
//
// flexShrink: 0 matters — without it the flex column squeezes this row to
// nothing when the list below is long.
//
// Card size is width*0.3 clamped to 110–200, image width*0.1 clamped to 40–70 —
// the same clamps the Dart applies so cards stay phone-sized on tablets.

import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import DeviceCard from './DeviceCard';

export default function CommonDevicesStrip({ devices, onOpen, onToggleFavourite }) {
  const theme = useTheme();
  const c = theme.sli;

  const vw = typeof window !== 'undefined' ? window.innerWidth : 400;
  const cardSize = Math.min(200, Math.max(110, vw * 0.3));
  const imgSize = Math.min(70, Math.max(40, vw * 0.1));

  if (!devices || devices.length === 0) {
    return (
      <Box sx={{ p: 2.5, flexShrink: 0 }}>
        <Typography sx={{ color: c.text }}>No Common Devices Found</Typography>
      </Box>
    );
  }

  return (
    // data-hscroll: a real horizontal scroller — the tab-swipe handler leaves
    // gestures that start in here alone (see useSwipeNav).
    <Box
      data-hscroll
      sx={{
        display: 'flex',
        overflowX: 'auto',
        px: 1,
        py: 1.5,
        gap: 2,
        flexShrink: 0,
      }}
    >
      {devices.map((d) => (
        <Box key={d.UniqueNumber} sx={{ width: cardSize, height: cardSize, flexShrink: 0 }}>
          <DeviceCard
            device={d}
            imageSize={imgSize}
            onOpen={onOpen}
            onToggleFavourite={onToggleFavourite}
          />
        </Box>
      ))}
    </Box>
  );
}
